// src/router/authGuards.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// src/router/authGuards.jsx
const getToken = () =>
  localStorage.getItem("authToken") || localStorage.getItem("demo-token");
const isPosPath = (pathname = "") => pathname.toLowerCase().startsWith("/pos");

export const isAuthenticated = () => !!getToken();

export function RequireAuth() {
  const location = useLocation();
  if (isAuthenticated()) return <Outlet />;
  const signinPath = isPosPath(location.pathname) ? "/pos/signin" : "/signin";
  return <Navigate to={signinPath} replace state={{ from: location }} />;
}

export function PublicOnly() {
  const location = useLocation();
  if (!isAuthenticated()) return <Outlet />;
  const homePath = isPosPath(location.pathname) ? "/pos" : "/index";
  return <Navigate to={homePath} replace />;
}
